import { useEffect, useRef, useState } from "react";
import CommonTable from "../../../components/comman/CommonTable";
import MainHeading from "../../../components/comman/MainHeading";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import { callApi } from "../../../ApiHelper/ApiHelper";
import moment from "moment";
import {
  calculateHours,
  formatTo12HourTime,
} from "../../../utility/CommonFunctions";
import { toast } from "react-toastify";
import { Nav, NavItem, NavLink, TabContent, Fade, TabPane } from "reactstrap";
import FilterComponent from "../../../components/comman/FilterComponent";
import AddLeaveModal from "../Leave/AddLeaveModal";
import { updateFiltersStates } from "../../../store/actions/UserActions";
import { useDispatch, useSelector } from "react-redux";

export default function AttendanceAdmin() {
  const [pageStates, setPageStates] = useState({
    activeTab: 1,
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    companyIsLoading: false,
    filterData: "",
    month: "",
    attendanceList: [],
    siteList: [],
    officeList: [],
    companyList: [],
    companyId: "",
    staffType: "1",
    myAttendance: "false",
    searchQuery: "",
    siteId: "",
    officeType: "",
    attendanceType: "",
    attendanceStatus: "",
    sortBySingleDate: [
      moment().format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD"),
    ],
    isInitial: false,
  });
  const [modal, setModal] = useState(false);
  const timeoutId = useRef(null);
  const dispatch = useDispatch();
  const filterDetails = useSelector((state) => state.root.filtersStates);

  const toggleModal = () => {
    setModal(!modal);
  };

  useEffect(() => {
    GetCompanyList();
  }, []);

  useEffect(() => {
    if (pageStates.activeTab == 2) {
      GetSiteList(filterDetails?.companyId);
    }
  }, [filterDetails?.companyId]);

  useEffect(() => {
    GetAttendance(pageStates?.currentPage);
  }, [
    pageStates?.currentPage,
    pageStates?.staffType,
    pageStates.searchQuery,
    pageStates.attendanceStatus,
    pageStates.attendanceType,
    filterDetails?.siteId,
    pageStates.officeType,
    pageStates?.sortBySingleDate,
    pageStates.pageSize,
    filterDetails?.companyId,
    filterDetails?.orderBy,
    pageStates.isInitial,
  ]);

  const getLeaveCount = (data) => {
    const option = {
      method: "GET",
    };
    const url =
      apiUrl.get_leave_count + `?type=${data?.type}&userId=${data?.userId}`;
    callApi(url, option).then((res) => {
      if (res?.status === true) {
        setPageStates((pre) => ({
          ...pre,
          listType: res?.data,
          userName: data?.userName,
          userId: data?.userId,
        }));
      } else {
        toast.error(res?.message);
      }
    });
  };

  const GetAttendance = (pageNo) => {
    let options = {
      method: "GET",
    };

    const Url =
      apiUrl.get_attendance +
      "?" +
      MainFilterHandler({
        ...pageStates,
        siteId: pageStates?.siteId,
        orderBy: filterDetails?.orderBy,
        companyId: filterDetails?.companyId,
      });
    setPageStates((pre) => ({
      ...pre,
      tableLoader: true,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: false,
      }));
      if (res?.status === true) {
        const newData = res?.data?.attendance?.map((item) => ({
          ...item,
          empNameWithImage: item?.name + "##" + item?.profilePhoto,
          attendanceDate: moment
            .utc(item?.attendances[0]?.checkInTime)
            .format("DD/MM/YYYY"),
          shiftTime: item?.Shift?.shiftName,
          departmentName: item?.department?.name,
          officeName: item?.site?.name,
          siteName: item?.usersites?.[0]?.site?.name,
          onRollCompany: item?.Company?.name,
          attendanceType: item?.attendances[0]?.isODrequest
            ? "OD Request"
            : item?.attendances[0]?.isARrequest
            ? "AR Request"
            : item?.attendances[0]?.status == 3
            ? "Leave"
            : "General",
          attendanceStatusToggle: item?.attendances[0]
            ? item?.attendances[0]?.status
            : 2,
          checkIn:
            item?.attendances[0]?.checkInTime &&
            formatTo12HourTime(item?.attendances[0]?.checkInTime),
          checkOut:
            item?.attendances[0]?.checkOutTime &&
            formatTo12HourTime(item?.attendances[0]?.checkOutTime),
          totalDuration:
            item?.attendances[0]?.checkOutTime &&
            calculateHours(
              item?.attendances[0]?.checkInTime,
              item?.attendances[0]?.checkOutTime
            ),
        }));
        setPageStates((pre) => ({
          ...pre,
          attendanceList: newData,
          count: res?.data?.pageInfo?.total,
          totalPages: res?.data?.pageInfo?.totalPages,
        }));
      }
    });
  };

  const toggleTab = (tab) => {
    if (tab == 1) {
      setPageStates((prev) => ({
        ...prev,
        companyId: "",
        staffType: "1",
        activeTab: tab,
        currentPage: 1,
        siteId: "",
      }));
      dispatch(
        updateFiltersStates({
          companyId: "",
        })
      );
      // GetSiteList(tab);
    } else {
      setPageStates((prev) => ({
        ...prev,
        companyId: "",
        staffType: "0",
        activeTab: tab,
        currentPage: 1,
        siteId: filterDetails?.siteId,
      }));
      dispatch(
        updateFiltersStates({
          companyId: "",
        })
      );
      GetSiteList();
    }
  };

  const HandleUpdateAttendance = (data) => {
    let newStatus;
    if (data?.status == 0) {
      newStatus = 1;
    } else if (data?.status == 1) {
      newStatus = 0;
    } else if (data?.status == 2) {
      newStatus = 1;
    }
    const submitData = {
      type: "attendance",
      id: data?.id,
      status: newStatus,
    };
    const options = {
      method: "POST",
      data: submitData,
    };
    let API = apiUrl?.user_status_update;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        toast.success(response?.message);
        GetAttendance(pageStates?.currentPage);
      } else {
        toast.error(response?.message);
      }
    });
  };

  const TableHeadingOffice = [
    { value: "empNameWithImage", label: "Employee" },
    { value: "employeeCode", label: "Emp. Code" },
    // { value: "attendanceDate", label: "Date" },
    { value: "attendanceStatusToggle", label: "Status" },
    { value: "checkIn", label: "Check In" },
    { value: "checkOut", label: "Check Out" },
    { value: "totalDuration", label: "Total Duration" },
    { value: "attendanceType", label: "Attendance Type" },
    { value: "shiftTime", label: "Shift" },
    { value: "departmentName", label: "Department" },
    { value: "officeName", label: "Office" },
    { value: "onRollCompany", label: "On Roll Company" },
  ];

  const CustomActionData = [
    {
      label: "Mark Present",
      className: "btn btn-sm btn-success",
      icon: "",
      title: "",
      isShow: 0,
      clickHandler: HandleUpdateAttendance,
    },
    {
      label: "Mark Present",
      className: "btn btn-sm btn-success",
      icon: "",
      title: "",
      isShow: 2,
      clickHandler: HandleUpdateAttendance,
    },
    {
      label: "Mark Absent",
      className: "btn btn-sm btn-danger",
      icon: "",
      title: "",
      isShow: 1,
      clickHandler: HandleUpdateAttendance,
    },
  ];

  const TableHeadingSite = [
    { value: "empNameWithImage", label: "Employee" },
    { value: "employeeCode", label: "Emp. Code" },
    // { value: "attendanceDate", label: "Date" },
    { value: "attendanceStatusToggle", label: "Status" },
    { value: "shiftTime", label: "Shift" },
    { value: "departmentName", label: "Department" },
    { value: "siteName", label: "Site" },
    { value: "onRollCompany", label: "On Roll Company" },
    { value: "attendanceType", label: "Attendance Type" },
    { value: "checkIn", label: "Check In" },
    { value: "checkOut", label: "Check Out" },
    { value: "totalDuration", label: "Total Duration" },
  ];

  const GetSiteList = (companyId = null, searchQuery = null) => {
    return new Promise((resolve) => {
      const API =
        apiUrl.get_site +
        `?&pageSize=100` +
        (companyId ? `&companyId=${companyId}` : "") +
        (searchQuery ? `&search=${searchQuery}` : "");

      setPageStates((prev) => ({
        ...prev,
        isLoadingSite: true,
      }));

      callApi(API, { method: "GET" })
        .then((response) => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));

          if (response?.status) {
            const formattedData = response.data?.site?.map((item) => ({
              value: item.id,
              label: item.name,
            }));

            const siteId = response.data?.site?.some(
              (item) => item?.id == filterDetails?.siteId
            );
            setPageStates((prev) => ({
              ...prev,
              ...(siteId ? { isInitial: false } : { siteId: "" }),
              siteList: formattedData || [],
            }));

            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));
          resolve([]);
        });
    });
  };

  const GetCompanyList = (inputValue) => {
    return new Promise((resolve) => {
      let API = `${apiUrl.get_company}${
        inputValue ? `?search=${inputValue}` : ""
      }`;
      let options = { method: "GET" };

      // Start Loading
      setPageStates((prev) => ({
        ...prev,
        companyIsLoading: true,
      }));

      // API Call
      callApi(API, options)
        .then((response) => {
          if (response?.status) {
            //  console.log("responce====>",response?.data?.purchase);
            const formattedData = response?.data?.company.map((company) => ({
              value: company.id,
              label: company.name,
            }));

            setPageStates((prev) => ({
              ...prev,
              companyIsLoading: false,
              companyList: formattedData,
            }));
            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          resolve([]);
        });
    });
  };

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
    }
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      setPageStates((prevState) => ({
        ...prevState,
        currentPage: 1,
        searchQuery: value,
      }));
    }, 300);
  };

  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1,
    }));
  };

  const sortHandler = (data, type) => {
    // console.log("DAAAAA", data);
    setPageStates((prevState) => ({
      ...prevState,
      ...(!type && { attendanceType: data?.attendanceType }),
      ...(!type && { attendanceStatus: data?.attendanceStatus }),
      ...(type === "site" && { siteId: data?.site }),
      // ...(type && { officeType: data?.office }),
      ...(type == "companyId" && { companyId: data?.companyId, siteId: "" }),
    }));
    dispatch(
      updateFiltersStates({
        ...(type === "site" && { siteId: data?.site }),
        ...(type === "companyId" && { companyId: data?.companyId }),
      })
    );
  };

  // printData("State", pageStates)

  const sortList = {
    attendanceStatus: [
      { value: "", label: "Select Attendance Status" },
      { value: 1, label: "Present" },
      { value: 0, label: "Absent" },
      { value: 2, label: "Pending" },
      { value: 3, label: "On Leave" },
    ],
    attendanceType: [
      { value: "", label: "Select Attendance Type" },
      { value: "odRequest", label: "OD Request" },
      { value: "arRequest", label: "AR equest" },
      { value: "general", label: "General" },
      { value: "leave", label: "Leave" },
    ],
    ...(pageStates.siteList && { site: pageStates.siteList }),
    companyList: pageStates?.companyList,
  };

  const sortListOffice = {
    attendanceStatus: [
      { value: "", label: "Select Attendance Status" },
      { value: 1, label: "Present" },
      { value: 0, label: "Absent" },
      { value: 2, label: "Pending" },
      { value: 3, label: "On Leave" },
    ],
    attendanceType: [
      { value: "", label: "Select Attendance Type" },
      { value: "odrequest", label: "OD Request" },
      { value: "arrequest", label: "AR equest" },
      { value: "general", label: "General" },
      { value: "leave", label: "Leave" },
    ],
    // ...(pageStates.officeList && { office: pageStates.officeList }),
    companyList: pageStates?.companyList,
  };

  const singleDateChangeHandler = (date) => {
    let formattedDate = null;

    if (date) {
      formattedDate = new Date(
        date.getTime() - date.getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
    }

    setPageStates((prevState) => ({
      ...prevState,
      sortBySingleDate: formattedDate
        ? [moment(formattedDate).format("YYYY-MM-DD")]
        : [],
    }));
  };

  const handleChangeAttendance = (newStatus, userId, userName) => {
    if (newStatus !== 3) {
      const submitData = {
        userId: userId,
        markingAttendance: true,
        status: newStatus,
        date: pageStates?.sortBySingleDate[0],
      };
      let options = {
        method: "POST",
        data: submitData,
      };
      const url = apiUrl.mark_attendance;
      callApi(url, options).then((res) => {
        if (res?.status === true) {
          toast.success("Attendance Updated");
          GetAttendance(pageStates?.currentPage);
        } else {
          toast.error(res?.message);
        }
      });
    } else {
      const data = {
        userName: userName,
        userId: userId,
        type: "remaining",
      };
      getLeaveCount(data);
      toggleModal();
      // printData(newStatus);
    }
  };

  const orderByHandler = (e) => {
    dispatch(
      updateFiltersStates({
        orderBy: e.target.value,
      })
    );
  };

  const orderByList = [
    { value: "", name: "Newest" },
    { value: "asc", name: "Oldest" },
  ];

  return (
    <>
      <div className="content">
        <MainHeading
          title={"Attendance"}
          // buttonText={"Apply Leave"}
          // buttonIcon={<PlusIcon />}
          // buttonLink={RoutesLink?.add_customer}
          // clickHandler={toggleModal}
          singleDateChangeHandler={singleDateChangeHandler}
          pageState={pageStates}
        />
        <Nav tabs className="nav nav-tabs border-0 mb-4">
          <NavItem className="nav-item">
            <NavLink
              className={
                pageStates?.activeTab === 1
                  ? "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-0 border-start-2 active"
                  : "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-0 border-start-2"
              }
              style={{ cursor: "pointer" }}
              onClick={() => toggleTab(1)}
            >
              Office Staff Attendance
            </NavLink>
          </NavItem>
          <NavItem className="nav-item ">
            <NavLink
              className={
                pageStates?.activeTab === 2
                  ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0 active"
                  : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0"
              }
              style={{ cursor: "pointer" }}
              onClick={() => toggleTab(2)}
            >
              Site Staff Attendance
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={pageStates?.activeTab}>
          <TabPane tabId={1}>
            <Fade in={pageStates?.activeTab === 1} timeout={200}>
              <div className="card mb-4">
                <div className="card-body">
                  <FilterComponent
                    filterArray={sortListOffice}
                    sortHandler={sortHandler}
                    handleSearch={handleSearchChange}
                    handleData={sortHandler}
                    pageStates={pageStates}
                    orderByHandler={orderByHandler}
                    orderByList={orderByList}
                    getCompany={GetCompanyList}
                  />
                  <CommonTable
                    TableHeading={TableHeadingOffice}
                    TableData={pageStates?.attendanceList}
                    // CustomActionData={CustomActionData}
                    currentPage={pageStates?.currentPage}
                    PageChangeHandler={PageChangeHandler}
                    isLoading={pageStates?.tableLoader}
                    totalPages={pageStates?.totalPages}
                    count={pageStates?.count}
                    handleChangePageSize={handleChangePageSize}
                    pageSize={pageStates.pageSize}
                    handleChangeAttendance={handleChangeAttendance}
                  />
                </div>
              </div>
            </Fade>
          </TabPane>
          <TabPane tabId={2}>
            <Fade in={pageStates?.activeTab === 2} timeout={200}>
              <div className="card mb-4">
                <div className="card-body">
                  <FilterComponent
                    filterArray={sortList}
                    sortHandler={sortHandler}
                    handleSearch={handleSearchChange}
                    handleData={sortHandler}
                    pageStates={pageStates}
                    orderByHandler={orderByHandler}
                    orderByList={orderByList}
                    setPageState={setPageStates}
                    getSite={GetSiteList}
                    getCompany={GetCompanyList}
                  />
                  <CommonTable
                    TableHeading={TableHeadingSite}
                    TableData={pageStates?.attendanceList}
                    // CustomActionData={CustomActionData}
                    currentPage={pageStates?.currentPage}
                    PageChangeHandler={PageChangeHandler}
                    isLoading={pageStates?.tableLoader}
                    totalPages={pageStates?.totalPages}
                    count={pageStates?.count}
                    handleChangePageSize={handleChangePageSize}
                    pageSize={pageStates.pageSize}
                    handleChangeAttendance={handleChangeAttendance}
                  />
                </div>
              </div>
            </Fade>
          </TabPane>
        </TabContent>
      </div>
      <AddLeaveModal
        isOpen={modal}
        onClose={toggleModal}
        EditLeaveData={null}
        Type={"leaveForUser"}
        state={pageStates}
        getLeave={GetAttendance}
        setState={setPageStates}
      />
    </>
  );
}
